import {
  InlineDatum,
  InlineDatumInput,
  InlineDatumReactComponent,
} from '../types';

export function isInputInlineDatum(
  datum: InlineDatum,
): datum is InlineDatumInput {
  return datum.datum_type === 'input';
}

export function isReactComponentInlineDatum(
  datum: InlineDatum,
): datum is InlineDatumReactComponent {
  return datum.datum_type === 'react_component';
}
